import { useEffect, useState } from 'react'
import { Checkbox, Input, Select, Tooltip } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import RelationThroughRules from './RelationThroughRules'
import FormLikeField from './FormLikeField'
import { QuestionCircleOutlined } from '@ant-design/icons'

RelationThroughConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()
  [isActive, setIsActive] = useState(false)
  [options, setOptions] = useState([])
  [search, setSearch] = useState(undefined)
  [rules, setRules] = useState([])

  useEffect( ->
    setIsActive(fieldData[fieldKey]?.save?.relationThrough)
    undefined
  , [fieldKey])

  useEffect( ->
    ( ->
      relKeyBindings = await new Weaver.Sparql("""
        SELECT DISTINCT ?key WHERE {
          ?s ?key ?o .
          FILTER(isIRI(?o))
        }
      """).find()
      setOptions(relKeyBindings.key.map(({ nodeId }) -> { label: nodeId, value: nodeId } ))
    )()
    undefined
  , [])

  setRelationThroughProp = (key) -> (value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'save', 'relationThrough', key], value)
      )
    )

  <>
    <FormLikeField label={
      <>
        Through relation?
        <Tooltip title="Use through relations to automatically create middle nodes between the subject of the form, and the target of a field in the form">
          <QuestionCircleOutlined style={{ marginLeft: 5, color: '#58bd91' }} />
        </Tooltip>
      </>
    }>
      <Checkbox
        checked={isActive}
        onChange={({ target: { checked }}) ->
          setIsActive(checked)
          unless checked
            dispatch(
              setFieldData(
                _.set(fieldData, [fieldKey, 'save', 'relationThrough'], undefined)
              )
            )
        }
      />
    </FormLikeField>
    { if isActive
      <>
        <FormLikeField label="Relation name">
          <Select
            showSearch
            onSearch={(val) -> setSearch(val) if val isnt ''}
            style={{ width: '100%' }}
            options={_.uniqBy(options.concat([{ value: search, label: search }]), 'value')}
            value={fieldData[fieldKey]?.save?.relationThrough?.relationName}
            onChange={setRelationThroughProp('relationName')}
            placeholder="Through relation key"
          />
        </FormLikeField>
        { if fieldData[fieldKey]?.type isnt 'select' && fieldData[fieldKey]?.type isnt 'selectOrCreate'
          <FormLikeField label="Data attribute">
            <Input
              value={fieldData[fieldKey]?.save?.relationThrough?.dataAttr}
              placeholder="Attribute key on through relation"
              onChange={({ target: { value }}) ->
                setRelationThroughProp('dataAttr')(value)
              }
            />
          </FormLikeField>
        }
        <FormLikeField label="Relation through rules">
          <RelationThroughRules
            value={fieldData[fieldKey]?.save?.relationThrough?.rules}
            onChange={setRelationThroughProp('rules')}
          />
        </FormLikeField>
      </>
    }
  </>

export default RelationThroughConfig
